export const GET_DATA_RETENTION_POLICIES = 'GET_DATA_RETENTION_POLICIES';
export const GET_DATA_RETENTION_POLICIES_SUCCESS = 'GET_DATA_RETENTION_POLICIES_SUCCESS';
export const GET_DATA_RETENTION_POLICIES_ERROR = 'GET_DATA_RETENTION_POLICIES_ERROR';
